import { render } from "./StudentVerification.vue?vue&type=template&id=4ce3b3c6&scoped=true"
import script from "./StudentVerification.vue?vue&type=script&lang=js"
export * from "./StudentVerification.vue?vue&type=script&lang=js"

import "./StudentVerification.vue?vue&type=style&index=0&id=4ce3b3c6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ce3b3c6"]])

export default __exports__